import { AppBar, AppBarProps } from '@mui/material'
import React, { FC } from 'react'

const AppBarWrapper: FC<AppBarProps> = ({ ...props }) => <AppBar {...props} />

export default AppBarWrapper
